export default __webpack_public_path__ + "static/media/img (3).a58d3fa6.jpg";